import _ from 'lodash'

const checkStringLength = url => !_.isString(url) || _.size(url) === 0

export const convertCdnResizeUrl = (url, resize = undefined) => {
  if (checkStringLength(url)) {
    return ''
  }

  let result = process.env.CDN_BASE_URL

  if (url.startsWith(result)) {
    return url
  }

  if (_.head(url) !== '/') {
    result = result + '/'
  }

  result = result + url

  if (resize) {
    result = result + resize
  }

  return result
}

export const convertPrfResizeUrl = (url, resize = undefined) => {
  if (checkStringLength(url)) {
    return '/images/icon/profile_noimg.png'
  } else {
    return convertCdnResizeUrl(url, resize)
  }
}

export const errorPrfImg = (e) => {
  e.target.src = '/images/icon/profile_noimg.png'
}

export const errorImg = (e) => {
  e.target.style.display = 'none'
}
